import createLucideIcon from '../createLucideIcon';

/**
 * @component @name LuMessageSquareDashed
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMyA2VjVjMC0xLjEuOS0yIDItMmgyIiAvPgogIDxwYXRoIGQ9Ik0xMSAzaDMiIC8+CiAgPHBhdGggZD0iTTE4IDNoMWMxLjEgMCAyIC45IDIgMiIgLz4KICA8cGF0aCBkPSJNMjEgOXYyIiAvPgogIDxwYXRoIGQ9Ik0yMSAxNWMwIDEuMS0uOSAyLTIgMmgtMSIgLz4KICA8cGF0aCBkPSJNMTQgMTdoLTMiIC8+CiAgPHBhdGggZD0ibTcgMTctNCA0di01IiAvPgogIDxwYXRoIGQ9Ik0zIDEydi0yIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/message-square-dashed
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LuMessageSquareDashed = createLucideIcon('LuMessageSquareDashed', [
  ['path', { d: 'M3 6V5c0-1.1.9-2 2-2h2', key: '9usibi' }],
  ['path', { d: 'M11 3h3', key: '1c3ji7' }],
  ['path', { d: 'M18 3h1c1.1 0 2 .9 2 2', key: '19esxn' }],
  ['path', { d: 'M21 9v2', key: 'p14lih' }],
  ['path', { d: 'M21 15c0 1.1-.9 2-2 2h-1', key: '1fo1j8' }],
  ['path', { d: 'M14 17h-3', key: '1w4p2m' }],
  ['path', { d: 'm7 17-4 4v-5', key: 'ph9x1h' }],
  ['path', { d: 'M3 12v-2', key: '856n1q' }],
]);

export default LuMessageSquareDashed;
